import React, { useEffect, useState } from "react";
import makeStyles from "@mui/styles/makeStyles";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { FirebaseApp } from "firebase/app";
import { MemberInfo, getMembersFromFirestore } from "../common/common";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 140,
  },
}));

type Props = {
  name: string;
  setName: React.Dispatch<React.SetStateAction<string>>;
  firebaseApp: FirebaseApp;
};
function MembersMenu(props: Props) {
  const { name, setName, firebaseApp } = props;
  const [memberList, setMemberList] = useState<MemberInfo[]>([]);

  const handleChange = (event: any) => {
    setName(event.target.value);
  };

  const classes = useStyles();

  useEffect(() => {
    getMembersFromFirestore(firebaseApp, setMemberList);
  }, [firebaseApp]);

  return (
    <FormControl className={classes.formControl}>
      <InputLabel id="label-name" sx={{ marginTop: "0.2rem" }}>
        配信者名
      </InputLabel>
      <Select
        id="member"
        labelId="label-name"
        value={name}
        displayEmpty
        variant="standard"
        onChange={handleChange}
      >
        {memberList.map((member) => (
          <MenuItem key={member.name} value={member.name}>
            {member.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default MembersMenu;
